import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Mirrors ProtectedRoute.jsx but redirects to the mobile login screen (/m/login)
// instead of the desktop one (/login), so unauthenticated visits to /m/* stay
// inside the mobile experience rather than bouncing to the desktop app.
export const MobileProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="mobile-app min-h-screen flex items-center justify-center bg-[#FAFAF9]" data-testid="mobile-auth-loading">
        <div className="text-xs uppercase tracking-[0.2em] text-[#78716C]">Loading...</div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/m/login" replace />;
  }

  return children;
};
